/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


// Google Maps Api Loader
define('global/GoogleMapsLoader',[
    'jquery',
    './Logger'
], function ($, Logger) {
    'use strict';

    var cfg = window.RocConfig;
    var googleMapsApiDef;
    var callbackName;
    var libraries = ['places'];

    function resolve() {
        googleMapsApiDef.resolve(window.google && window.google.maps ? window.google.maps : false);
    }

    function loadApi() {
        if (googleMapsApiDef) {
            return googleMapsApiDef.promise();
        }

        googleMapsApiDef = new $.Deferred();

        // if google.maps already exists then resolve the promise because Google Maps API was loaded before
        if (window.google && window.google.maps) {
            resolve();
        } else {
            callbackName = 'googleMapsLoaded_' + new Date().getTime();
            var params = {
                'libraries': libraries.join(','),
                'callback': callbackName
            };

            if (cfg.google && cfg.google.mapsApiKey) {
                params['key'] = cfg.google.mapsApiKey;
            } else {
                Logger.warn('GoogleMapsLoader: RocConfiguration has no API key,  you can generate a new API key on the Google Developers Console');
            }

            // declare the global callback
            window[callbackName] = function () {
                resolve();

                // delete callback because it's not needed
                setTimeout(function() {
                    try {
                        delete window[callbackName];
                    } catch (e) {
                    }
                });
            };

            $.ajax({
                dataType: 'script',
                data: params,
                url: '//maps.googleapis.com/maps/api/js'
            });

        }

        return googleMapsApiDef.promise();
    }

    // BEGIN CUSTOMIZATIONS FOR HT: helper methods for branch locator

    //**************************** 
    // Distance helpers 
    //****************************
    var distanceResponse;
    var distanceRequestLength;
    var distanceCallback;

    function splitRequest(distances, n) {
        var result = _.groupBy(distances, function (element, index) {
            return Math.floor(index / n);
        });
        return _.toArray(result);
    }

    function callGoogleMapsDistance(origin, destination) {
        var service = new google.maps.DistanceMatrixService();
        service.getDistanceMatrix(
            {
                origins: origin,
                destinations: _.map(destination, function (value) { return value.address }),
                travelMode: google.maps.TravelMode.DRIVING,
                unitSystem: google.maps.UnitSystem.IMPERIAL,
                avoidHighways: false,
                avoidTolls: false
            }, function (response, status) {
                if (status == google.maps.DistanceMatrixStatus.OK) {
                    prepareGoogleMapsDistanceResponse(destination, response)
                }
            });
    }

    function prepareGoogleMapsDistanceResponse(request, response) {
        if (!response) {
            distanceResponse = [];
        } else {
            var addresess = response.destinationAddresses;
            var directions = response.rows[0].elements;

            $.each(directions, function (index, value) {
                distanceResponse.push(
                    {
                        locationId: request[index].locationId,
                        distance: value
                    });
            });
        }

        if (distanceResponse.length === distanceRequestLength) {
            distanceCallback(distanceResponse)
        }
    }

    function getDistance(origin, destination, callback) {
        distanceRequestLength = destination.length;
        distanceCallback = callback;
        distanceResponse = [];

        if (!$.isArray(origin)) {
            origin = [origin];
        }

        if (!$.isArray(destination)) {
            destination = [destination];
        }

        var destinationRequests = splitRequest(destination, 25);
        var delay = 250;
        $.each(destinationRequests, function (index, values) {

            window.setTimeout(function () {
                callGoogleMapsDistance(origin, values);
            }, delay);
            delay += 250
        })
    }

    function getZipCode(latitude, longitude, callback) {
        var postalCode = null;
        var service = new google.maps.Geocoder();
        service.geocode({ location: new google.maps.LatLng(latitude, longitude) }, function (results, status) {
            var component = _.find(results, function (result) {
                return _.some(result.types, function (type) { return type === 'postal_code' })
            });
            if (component) {
                var postalCodeComponent = _.find(component.address_components, function (comp) {
                    return _.some(comp.types, function (type) { return type === 'postal_code' })
                });
                if (postalCodeComponent) {
                    postalCode = postalCodeComponent.long_name;
                }
            }
            callback(postalCode);
        });
    }

    // END CUSTOMIZATIONS

    var GoogleMapsLoader = {
        getDistance: getDistance,
        getZipCode: getZipCode,
        loadApi: loadApi
    };

    Logger.debug('GoogleMapsLoader.js Loaded:', GoogleMapsLoader);

    return GoogleMapsLoader;
});
